<template>
  <div class="container">
    <div class="features-section">
      <div class="row">
        <div class="col-lg-3" v-for="item in contactPersons" v-bind:key="item.id">
          <div class="feature-box bg-white">
            <img v-if="item.profileImageUrl"
            :src="`${baseUrl}${item.profileImageUrl}`"
              alt="first & lastname"
              class="contact-img"
            />
            <i v-else class="icon-user-2"></i>
            <div class="feature-box-content p-0">
              <h3>{{ item.firstName }}  {{ item.lastName }}</h3>
              <h5>Komercijalist</h5>
              <div class="person-contact-info" v-if="item.phoneNumber">
                <i class="fa fa-mobile-alt"></i>
                <a :href="'tel:' + item.phoneNumber">{{ item.phoneNumber }}</a>
              </div>
              <div class="person-contact-info" v-if="item.email">
                <i class="far fa-envelope"></i>
                <!--<p>amina.rush@hymynameis.com</p>-->
                <a :href="'mailto:' + item.email">{{ item.email }}</a>
              </div>
            </div>
            <!-- End .feature-box-content -->
          </div>
          <!-- End .feature-box -->
        </div>
        <!-- End .col-lg-3 -->
      </div>
      <!-- End row -->
    </div>
    <!-- End features-section -->
    <div class="companies-section">
      <hr />
      <div class="row">
        <div class="col-md-6">
          <h4>Eurosan d.o.o.</h4>
          <p>Radno vrijeme:</p>
          <p>Ponedjeljak - Petak: 07:30-16:00</p>
          <p>Subota (od 6. do 10. mjeseca): 08:00-12:00</p>
          <a href="https://goo.gl/maps/YWB7oQTBPXhwPqoR8"
            ><i class="fas fa-map-marker-alt contact-icons" style="padding-left: 11px"></i> Bišće
            polje bb, 88000 Mostar</a
          >
          <a href="tel:+38736342220"><i class="fas fa-phone contact-icons"></i> +387 36 342 220</a>
          <a href="tel:+38736352743"
            ><i class="fas fa-fax contact-icons" style="padding-left: 9px"></i> +387 36 352 743</a
          >
          <a href="mailto:info@eurosan.ba"
            ><i class="fas fa-envelope contact-icons" style="padding-left: 9px"></i>
            info@eurosan.ba</a
          >
        </div>
        <!--end col-6-->
        <div class="col-md-6">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2903.681832715773!2d17.828039576784526!3d43.29998427112103!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x134b4299d1676727%3A0x20f1dc01f870ddf4!2sEurosan%20d.o.o.%20Mostar!5e0!3m2!1shr!2sba!4v1692183765763!5m2!1shr!2sba"
            width="100%"
            height="300"
            style="border: 0"
            allowfullscreen=""
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
        <!--end col-6-->
      </div>
      <!--end row-->

      <hr />
      <div class="row">
        <div class="col-md-6">
          <h4>Ecotime d.o.o.</h4>
          <p>Radno vrijeme:</p>
          <p>Ponedjeljak - Petak: 08:00-16:00</p>
          <p>Subota: 08:00-12:00</p>
          <a href="https://goo.gl/maps/4Ld9KvJApXz9wpff7">
            <i class="fas fa-map-marker-alt contact-icons"></i> Lužansko polje 7, 71210 Ilidža</a
          >
          <a href="tel:+38736342220"><i class="fas fa-phone contact-icons"></i> +387 33 765 075</a>
          <a href="tel:+38736352743"
            ><i class="fas fa-fax contact-icons" style="padding-left: 9px"></i> +387 33 765 085</a
          >
          <a href="mailto:prodaja@ecotime.ba"
            ><i class="fas fa-envelope contact-icons" style="padding-left: 9px"></i>
            prodaja@ecotime.ba</a
          >
        </div>
        <!--end col-6-->
        <div class="col-md-6">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2878.107430456347!2d18.291299776807104!3d43.832870371094124!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4758ca5d7d2e4597%3A0x211b0ce4b3fd7f05!2sEcotime%20d.o.o.%20Sarajevo!5e0!3m2!1shr!2sba!4v1692185268240!5m2!1shr!2sba"
            width="100%"
            height="300"
            style="border: 0"
            allowfullscreen=""
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
        <!--end col-6-->
      </div>
      <!--end row-->

      <hr />
      <div class="row">
        <div class="col-md-6">
          <h4>Eurosan Banja Luka d.o.o.</h4>
          <p>Radno vrijeme:</p>
          <p>Ponedjeljak - Petak: 08:00-16:00</p>
          <p>Subota: 09:00-13:00</p>
          <a href="https://goo.gl/maps/u8GBpPAxy4MPhhe19">
            <i class="fas fa-map-marker-alt contact-icons"></i>
            Jovana Bijelića bb, 78000 Banja Luka
          </a>
          <a href="tel:+38736342220">
            <i class="fas fa-phone contact-icons"></i>
            +387 51 456 652
          </a>
          <a href="tel:+38736352743">
            <i class="fas fa-fax contact-icons" style="padding-left: 9px"></i>
            +387 51 450 101
          </a>
          <a href="mailto:info@eurosan.rs.ba">
            <i class="fas fa-envelope contact-icons" style="padding-left: 9px"></i>
            info@eurosan.rs.ba
          </a>
        </div>
        <!--end col-6-->
        <div class="col-md-6">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2829.9715873409664!2d17.196973176849564!3d44.822143471070696!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x475e03700911b24f%3A0xb0d1f4fd90868d9d!2sEurosan%20doo%20Banja%20Luka!5e0!3m2!1shr!2sba!4v1692185647279!5m2!1shr!2sba"
            width="100%"
            height="300"
            style="border: 0"
            allowfullscreen=""
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
        <!--end col-6-->
      </div>
      <!--end row-->
    </div>
    <!--end companies section-->
    <div class="mb-8"></div>
  </div>
</template>

<script>
import api from '@/services/api';
import config from '@/config';

export default {
  name: 'Contact',
  data() {
    return {
      center: {
        title: 'XSOFT d.o.o',
        address1: 'Vukovarska 18b',
        address2: 'Mostar 88000, Bosnia and Herzegovina',
        placeId: 'ChIJbcik5rxDSxMRPgHkpe3Gs9E',
        lat: 43.352585,
        lng: 17.799112,
      },
      locationMarkers: [
        {
          title: 'XSOFT d.o.o',
          address1: 'Vukovarska 18b',
          address2: 'Mostar 88000, Bosnia and Herzegovina',
          coords: { lat: 43.352585, lng: 17.799112 },
          placeId: 'ChIJbcik5rxDSxMRPgHkpe3Gs9E',
        },
      ],
      locPlaces: [],
      existingPlace: null,
      contactPersons: [],
    };
  },
  computed: {
    baseUrl() {
      return config.baseUrl;
    },
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    api.getContactPersons().then((response) => {
      this.contactPersons = response.data.data;
    });
  },
};
</script>
<style scopped lang="scss">
.profile-icon-wrapper {
  i {
    font-size: 8rem;
  }
}

/*Contact New*/

.companies-section h4 {
  color: #1e84bc;
}

.companies-section p {
  margin-bottom: 5px;
  color: #1e84bc;
}

.companies-section a {
  display: block;
  margin-top: 10px;
  font-weight: bold;
}

.contact-icons {
  background: #1e84bc;
  border-radius: 50%;
  padding: 10px 10px 10px 10px;
  color: #ffffff;
  width: 31px;
  height: 31px;
  margin-right: 10px;
}

@media (max-width: 575px) {
  .companies-section a:last-child {
    margin-bottom: 20px;
  }
}
</style>
